import { useEffect, useState } from 'react'
import {
  Burger, LogoWrapper,
  DesktopLogout,
  MobileCenterChoice,
  MobileCentersChoice, MobileCentersList,
  MobileCentersTitle,
  MobileClose, MobileHeader, MobileLogout, MobileLogoWrapper, SideMenuWrapper
} from './styles'
import Logo from 'components/Logo'
import MenuItem from 'pages/components/Template/components/SideMenu/components/MenuItem'
import HomeIcon from './assets/home.svg'
import FacturationIcon from './assets/facturation.svg'
import ClientsIcon from './assets/clients.svg'
import MailsIcon from './assets/mails.svg'
import ExportsIcon from './assets/exports.svg'
import FreeAnswerIcon from './assets/freeAnswer.svg'
import BurgerIcon from './assets/burger.svg'
import MobileCloseIcon from './assets/mobile-close.svg'
import { useTranslation } from 'react-i18next'
import Overlay from 'components/Overlay'
import { useHistory, useLocation } from 'react-router-dom'
import Button from 'components/Button'
import colors from 'globals/colors'
import { Address } from 'globals/models/User'
import { ReactComponent as ArrowUpIcon } from 'components/ChooseCenter/assets/arrow-up.svg'
import { ReactComponent as ArrowDownIcon } from 'components/ChooseCenter/assets/arrow-down.svg'
import { CheckIcon } from 'components/Icons'
import { useMutation } from '@apollo/client'
import {
  CHANGE_CURRENT_ADDRESS,
  ChangeCurrentAddressResult,
  ChangeCurrentAddressVariables,
  SelectAllAddressesResult,
  SELECT_ALL_ADDRESSES
} from 'components/ChooseCenter/mutations'
import { displayErrors, DoMutation, hasNoError } from 'globals/graphql'
import GraphQLHandler from 'components/GraphQLHandler'
import * as H from 'history'

interface IProps {
  activeItem?: string,
  addresses: Address[],
  currentCenters: Address[]
}

const SideMenu = (props: IProps) => {
  const { activeItem, addresses, currentCenters } = props
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()

  const [isActive, setActive] = useState(false)
  const [centersOpened, setCentersOpened] = useState(false)
  const [allAddressesSelected, setAllAddressesSelected] = useState<boolean>(false)

  useEffect(() => {
    if (currentCenters.length > 1) {
      setAllAddressesSelected(true)
    }
  }, [currentCenters])

  const onSelectAddress = (
    doChangeCurrentAddress: DoMutation<ChangeCurrentAddressResult, ChangeCurrentAddressVariables>,
    newAddressId: number
  ) =>
    doChangeCurrentAddress({
      variables: {
        addressId: newAddressId
      }
    }).then(hasNoError(() =>
      window.location.reload()
    ))

  const onSelectAllAddresses = (
    doSelectAllAddresses: DoMutation<SelectAllAddressesResult>
  ) => {
    doSelectAllAddresses().then(hasNoError(() => {
      window.location.reload()
    }
    ))
  }

  const onLogout = (history: H.History) => () => {
    localStorage.removeItem('token')
    history.push('/login')
  }

  return (
    <>
      <Overlay
        visible={isActive}
        onClick={() => setActive(false)}
      />

      <MobileHeader>
        <MobileLogoWrapper>
          <Logo color="white" />
        </MobileLogoWrapper>

        <Burger
          onClick={() => setActive(true)}
        >
          <img src={BurgerIcon} alt="Burger" />
        </Burger>
      </MobileHeader>

      <SideMenuWrapper active={isActive}>
        <LogoWrapper>
          <Logo color="white" />

          <Logo color="blue" />
        </LogoWrapper>

        <MobileClose
          onClick={() => setActive(false)}
        >
          <img
            src={MobileCloseIcon}
            alt="Close"
          />
        </MobileClose>

        <MenuItem
          to="/"
          icon={HomeIcon}
          text={t('side-menu.home')}
          active={activeItem ? activeItem === '/' : location.pathname === '/'}
        />

        <MenuItem
          to="/clients"
          icon={ClientsIcon}
          text={t('side-menu.clients-list')}
          active={activeItem ? activeItem === '/clients' : location.pathname === '/clients'}
        />

        <MenuItem
          to="/mails"
          icon={MailsIcon}
          text={t('side-menu.mails')}
          active={activeItem ? activeItem === '/mails' : location.pathname === '/mails'}
        />

        <MenuItem
          to="/exports"
          icon={ExportsIcon}
          text={t('side-menu.exports')}
          active={activeItem ? activeItem === '/exports' : location.pathname === '/exports'}
        />

        {currentCenters.length === 1 && currentCenters[0].partnerBillingSpace && (
          <MenuItem
            to="/facturation"
            icon={FacturationIcon}
            text={t('side-menu.facturation')}
            active={activeItem ? activeItem === '/facturation' : location.pathname === '/facturation'}
          />
        )}

        {
          currentCenters.filter((center: Address) => (
            center.externallyManaged
          )).length > 0 &&
          <MenuItem
            to="/libre-réponses"
            icon={FreeAnswerIcon}
            text={t('side-menu.free-answers')}
            active={activeItem ? activeItem === '/libre-réponses' : location.pathname === '/libre-réponses'}
          />
        }

        <GraphQLHandler
          mutations={{

            changeCurrentAddress: useMutation<
              ChangeCurrentAddressResult, ChangeCurrentAddressVariables
            >(CHANGE_CURRENT_ADDRESS, displayErrors),
            selectAllAddresses: useMutation<SelectAllAddressesResult>(SELECT_ALL_ADDRESSES, displayErrors)
          }}
        >
          {({ mutations: {
            changeCurrentAddress: [doChangeCurrentAddress],
            selectAllAddresses: [doSelectAllAddresses]
          } }) =>
            <>
              <MobileCentersChoice>
                <MobileCentersTitle
                  onClick={() => setCentersOpened(!centersOpened)}
                >
                  <span>{t('global.centers')}</span>

                  {centersOpened ?
                    <ArrowUpIcon /> :
                    <ArrowDownIcon />
                  }
                </MobileCentersTitle>

                <MobileCentersList
                  show={centersOpened}
                >
                  {addresses.length > 1 &&
                    <MobileCenterChoice
                      selected={allAddressesSelected}
                      onClick={() => {
                        onSelectAllAddresses(doSelectAllAddresses)
                        setAllAddressesSelected(true)
                      }}>Tous les centres {allAddressesSelected && <CheckIcon />}</MobileCenterChoice>
                  }
                  {addresses.map((address) =>
                    <MobileCenterChoice
                      key={address.id}
                      selected={currentCenters.length === 1 && address.id === currentCenters[0].id ? true : false}
                      onClick={() => {
                        onSelectAddress(doChangeCurrentAddress, address.id)
                        setAllAddressesSelected(false)
                      }}
                    >
                      {address.shortname} <CheckIcon />
                    </MobileCenterChoice>
                  )}
                </MobileCentersList>
              </MobileCentersChoice>

              <DesktopLogout>
                <Button
                  color={colors.purple}
                  onClick={onLogout(history)}
                >
                  {t('global.disconnect')}
                </Button>
              </DesktopLogout>

              <MobileLogout>
                <Button
                  color={colors.purple}
                  onClick={onLogout(history)}
                >
                  {t('global.disconnect')}
                </Button>
              </MobileLogout>
            </>
          }
        </GraphQLHandler>
      </SideMenuWrapper>
    </>
  )
}

export default SideMenu
